





































import i18n from "@/i18n";
import { stringToBoolOrDefault } from "@microsoft/applicationinsights-common";
import { Step } from "element-ui";
import { Component, Vue, Watch } from "vue-property-decorator";
import { ProfileApi } from "../api/profile";
import { UserSteps } from "../classes/userSteps";

@Component({
  name: "step-tracker",
})
export default class StepTracker extends Vue {
  public steps?: UserSteps;
  public profileApi: ProfileApi;
  public appTitle: string = "";
  public appContent: string = "";
  public integrationTitle: string = "";
  public integrationContent: string = "";

  hasMobile: boolean = false;
  hasIntegration: boolean = false;

  constructor() {
    super();
    this.profileApi = new ProfileApi();
  }
  public async mounted() {
    this.steps = await this.profileApi.getSteps();
    this.appTitle = this.steps.hasMobileApp ? i18n.t('stepTracker.appInstalled').toString() : i18n.t('stepTracker.installApp').toString()
    this.appContent = this.steps.hasMobileApp ? i18n.t('stepTracker.appInstalledContent').toString() : i18n.t('stepTracker.installAppContent').toString()
    this.integrationTitle = this.steps.hasAnyIntegration ? i18n.t('stepTracker.shopIntegrated').toString() : i18n.t('stepTracker.integrateShop').toString()
    this.integrationContent = this.steps.hasAnyIntegration ? i18n.t('stepTracker.shopIntegratedContent').toString() : i18n.t('stepTracker.integrateShopContent').toString()
    this.hasMobile = this.steps.hasMobileApp;
    this.hasIntegration = this.steps.hasAnyIntegration;
  }
}
